import { render, staticRenderFns } from "./Add_news.vue?vue&type=template&id=2694433e&scoped=true&"
import script from "./Add_news.vue?vue&type=script&lang=js&"
export * from "./Add_news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2694433e",
  null
  
)

export default component.exports